import React from "react";
import { useNavigate } from "react-router-dom";
import { Instagram, Megaphone } from "lucide-react";

interface HeaderProps {
  onNavigateToProperties: () => void;
  onNavigateToAbout: () => void;
  onAnnounceClick: () => void;
}

function Header({
  onNavigateToProperties,
  onNavigateToAbout,
  onAnnounceClick,
}: HeaderProps) {
  const navigate = useNavigate();

  const handleAnnounce = () => {
    navigate("/anuncie");
    if (onAnnounceClick) {
      onAnnounceClick();
    }
  };

  const handleNavigateToProperties = () => {
    navigate("/search-grid");
    if (onNavigateToProperties) {
      onNavigateToProperties();
    }
  };

  const handleNavigateToAbout = () => {
    // Se já estiver na home, faz scroll para a seção
    if (window.location.pathname === '/' || window.location.pathname === '') {
      const aboutSection = document.querySelector('#about-section');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Se não estiver na home, navega para a home e depois faz scroll
      navigate('/');
      setTimeout(() => {
        const aboutSection = document.querySelector('#about-section');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
    if (onNavigateToAbout) {
      onNavigateToAbout();
    }
  };
  return (
    <header className="flex h-20 px-4 lg:px-10 justify-between items-center bg-white">
      {/* Logo */}
      <a href="/" className="flex items-center">
        <img
          src="/logo-client.png"
          alt="Logo"
          className="h-[35px] w-auto object-contain"
        />
      </a>

      <nav className="hidden ml-24 lg:flex items-center gap-8 xl:gap-20">
        <div className="flex items-center gap-8 xl:gap-32">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleNavigateToProperties();
            }}
            className="text-xl font-bold text-gray-text hover:text-yellow-primary transition-colors leading-7"
          >
            Imóveis
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleNavigateToAbout();
            }}
            className="text-xl font-bold text-gray-text hover:text-yellow-primary transition-colors leading-7"
          >
            Sobre
          </a>
          <a
            href="https://www.instagram.com/desordibroker?igsh=NHdwcGg2Ym9ocHZm"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <Instagram className="w-6 h-6 text-gray-text hover:text-yellow-primary transition-colors" />
          </a>
        </div>
      </nav>

      {/* Botão Anuncie Aqui */}
      <button
        onClick={handleAnnounce}
        className="flex gap-2 h-12 items-center justify-center px-8 py-4 rounded-[135px] border border-yellow-primary text-yellow-primary hover:bg-yellow-primary hover:text-white transition-all duration-200 group"
      >
        <Megaphone className="w-6 h-6 text-yellow-primary group-hover:text-white transition-colors" />
        <span className="text-xl font-normal text-yellow-primary group-hover:text-white leading-none whitespace-nowrap transition-colors">
          Anuncie aqui
        </span>
      </button>
    </header>
  );
}

export { Header, type HeaderProps };
export default Header;